import React, { Dispatch, SetStateAction } from "react";
import { TYPO } from "styles/Typo";
import CenterModal from "components/common/Modal/CenterModal";
import useModalClickOutside from "utils/useModalClickOutside";
interface Props {
  setIsOpenDeleteModal: Dispatch<SetStateAction<boolean>>;
  deleteHandler: () => Promise<void>;
  isOpenDeleteModal: boolean;
  title: string;
  subTitle: string;
  portfolioDelete?: any;
}

function DeleteModal({
  isOpenDeleteModal,
  setIsOpenDeleteModal,
  deleteHandler,
  title,
  subTitle,
  portfolioDelete,
}: Props) {
  const modalRef = useModalClickOutside(setIsOpenDeleteModal); // 모달 참조를 위한 ref 추가

  return (
    <CenterModal
      modalRef={modalRef}
      containerClass="flex flex-col text-[#111111] border gap-4   w-80 "
    >
      <div className="flex flex-col gap-1">
        <h1 className={`${TYPO.TYPO5_SB} text-gray80`}>{title}</h1>
        <p className={`${TYPO.TYPO7_MD} text-gray60`}>{subTitle}</p>
      </div>

      <section className={`${TYPO.TYPO6_SB} flex gap-[15px] `}>
        <button
          className="cursor-pointer bg-gray5 p-3 rounded-xl text-gray60 flex-1"
          onClick={() => {
            portfolioDelete && portfolioDelete.fail("user_cancel");
            setIsOpenDeleteModal(false);
          }}
        >
          {"취소"}
        </button>
        <button
          className="cursor-pointer bg-red50 p-3 rounded-xl text-white flex-1  disabled:bg-[#D1D5DB]"
          onMouseDown={deleteHandler}
        >
          <p>{"삭제하기"}</p>
        </button>
      </section>
    </CenterModal>
  );
}

export function PortfolioDeleteModal({
  isOpenDeleteModal,
  setIsOpenDeleteModal,
  deleteHandler,
  title,
  subTitle,
}: any) {
  const modalRef = useModalClickOutside(setIsOpenDeleteModal); // 모달 참조를 위한 ref 추가

  return (
    <CenterModal
      modalRef={modalRef}
      containerClass="flex flex-col text-[#111111] border gap-4   w-80 "
    >
      <div className="flex flex-col gap-1">
        <h1 className={`${TYPO.TYPO5_SB} text-gray80`}>{title}</h1>
        <p className={`${TYPO.TYPO7_MD} text-gray60`}>{subTitle}</p>
      </div>

      <section className={`${TYPO.TYPO6_SB} flex gap-[15px] `}>
        <button
          className="cursor-pointer bg-gray-200 p-3 rounded-xl text-black flex-1"
          onClick={() => setIsOpenDeleteModal(false)}
        >
          {"취소"}
        </button>
        <button
          className="cursor-pointer bg-red-500 p-3 rounded-xl text-white flex-1  disabled:bg-[#D1D5DB]"
          onMouseDown={deleteHandler}
        >
          <p>{"삭제하기"}</p>
        </button>
      </section>
    </CenterModal>
  );
}

export default DeleteModal;
